export default {"src":"/_next/static/media/gold-bar.0a2cfe45.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};